export const LayoutFieldsProviderSymbol = Symbol.for("LayoutFieldsProvider");
